import { SxProps, Theme } from "@mui/material/styles";
import theme from "../../../theme";

const stylesParcours: SxProps<Theme> = [
  {
    "& .bloc-choixParcours": {
      border: "1px solid " + theme.palette.primary.main,
      padding: "12px 24px",
    },
  },
];

export default stylesParcours;
